import { registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./toolbarButton.html";
import LightningElementSLDS from 'util/lightningElementSLDS';
import { eventTypes, fireEvent, registerListener, unregisterAllListeners } from 'util/pubsub';
class ToolbarButton extends LightningElementSLDS {
  //exposing imported functions & enums - end
  //@api hideButton;//show only the panel , do not display the button

  constructor() {
    super();
    this.callOnClick = void 0;
    this.callOnInit = void 0;
    this.pdfViewerMainPane = void 0;
    //exposing imported functions & enums - start
    this.fireEventRef = fireEvent;
    this.registerListenerRef = registerListener;
    this.unregisterAllListenersRef = unregisterAllListeners;
    this.eventTypesRef = eventTypes;
    this.pageRef = {
      attributes: {
        "developer": "zPaper",
        "application": "Document Viewer"
      }
    };
  }
  handleClick(evt) {
    console.log("handleClick start");
    evt.container = this.template;
    evt.toolbarButton = this;
    if (this.callOnClick) {
      this.callOnClick(evt);
    }
    console.log("handleClick end");
  }
  handleInit() {
    console.log("handleInit start");
    if (this.callOnInit) {
      console.log("calling callOnInit - start");
      let evt = {
        container: this.template,
        toolbarButton: this
      };
      this.callOnInit(evt);
      console.log("calling callOnInit - end");
      console.log(this.template);
    } else {
      console.log("callOnInit does not have any value");
    }
    console.log("handleInit end");
  }
  getDomElement() {
    return this.template.querySelector("button");
  }
}
_registerDecorators(ToolbarButton, {
  publicProps: {
    callOnClick: {
      config: 0
    },
    callOnInit: {
      config: 0
    },
    pdfViewerMainPane: {
      config: 0
    },
    fireEventRef: {
      config: 0
    },
    registerListenerRef: {
      config: 0
    },
    unregisterAllListenersRef: {
      config: 0
    },
    eventTypesRef: {
      config: 0
    },
    pageRef: {
      config: 0
    }
  },
  publicMethods: ["handleInit", "getDomElement"]
});
export default _registerComponent(ToolbarButton, {
  tmpl: _tmpl
});